import React, {Component} from 'react';
import {DOMAIN} from "../api-config";
import {withRouter} from 'react-router-dom'
import i18n from "../i18n";
import $ from "jquery";

class language extends Component {

    constructor(props, context) {
        super(props, context);
        console.log(DOMAIN);

        this.state = {

            language:["en","es"],
            langname:["English","Spanish"]
        };

    };


    componentWillMount() {

    }
    changeLanguage=e=>{


        localStorage.setItem("store_language",$(e.target).val());

        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
    }

    componentDidMount() {


    }

    render() {

        var lang=localStorage.getItem("store_language");


        return (
            <div id="language">
                Select Language<br/>
                <select onChange={this.changeLanguage}>

                    {this.state.language.map((item, index) => {
                        var checked = (item=== lang) ? true : false;

                        return (<option value={item} selected={checked} >{this.state.langname[index]}
                        </option>)
                    })}

                </select>
            </div>
        );
    }
}


export default withRouter(language);


// WEBPACK FOOTER //
// ./src/view_components/language.js